import type {CSSProperties} from 'react';
import {WEDGE_SHELL as B} from '@territory/tokens';
import {font, radius, space} from '../scale.js';

export type WedgeAuthAlertLook = 'field-error' | 'form-error' | 'compact-warning' | 'verify-success' | 'verify-warning' | 'in-app' | 'in-app-guard';
/* Released native notice type and spacing, including the off-scale 12.5px field/banner text. */
const SMALL_NOTICE_FONT = font.footnote - 0.5;
const VERIFY_PAD = '10px 14px';
const VERIFY_GAP = 10;
export function wedgeAuthAlertStyle(look: WedgeAuthAlertLook): CSSProperties {
  if (look === 'field-error' || look === 'form-error') return {
    color: B.redText, fontSize: SMALL_NOTICE_FONT, lineHeight: 1.4,
    padding: `${space[2]}px ${space[3]}px`, background: look === 'form-error' ? B.formErrorSurface : B.fieldErrorSurface,
    border: `1px solid ${look === 'form-error' ? B.formErrorBorder : B.fieldErrorBorder}`, borderRadius: radius.md,
  };
  if (look === 'compact-warning') return {
    fontSize: SMALL_NOTICE_FONT, padding: '10px 12px', borderRadius: radius.md,
    background: B.inAppNoticeSurface, border: `1px solid ${B.compactWarningBorder}`,
    color: B.warningControlInk, lineHeight: 1.45, textAlign: 'left',
  };
  if (look === 'in-app' || look === 'in-app-guard') return {
    fontSize: SMALL_NOTICE_FONT, padding: look === 'in-app-guard' ? '10px 12px' : `${space[3]}px ${space[3]}px`, borderRadius: radius.md,
    background: B.inAppNoticeSurface, border: `1px solid ${B.inAppNoticeBorder}`,
    color: B.warningControlInk, lineHeight: 1.5, textAlign: 'left',
  };
  const success = look === 'verify-success';
  /* Existing fixed emerald tint and amber edge have the exact released feedback values. */
  const tint = success ? B.resendSurface : B.verifyWarningTint;
  return {
    padding: VERIFY_PAD, borderRadius: radius.lg,
    background: `linear-gradient(${tint}, ${tint}), ${B.bg}`,
    border: `1px solid ${success ? B.verifySuccessBorder : B.signupBorder}`,
    color: B.text, fontSize: font.body, lineHeight: 1.45, fontFamily: B.fontBody,
    boxShadow: B.verifyShadow, display: 'flex', alignItems: 'center', gap: VERIFY_GAP,
  };
}
